import type { ReactNode } from 'react';

export const symbol_accessibility_new: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M428.5-755.5Q407-777 407-807t21.5-51.5Q450-880 480-880t51.5 21.5Q553-837 553-807t-21.5 51.5Q510-734 480-734t-51.5-21.5ZM373-110v-503q-58-5-113.5-11.5T153-642q-14-3-21-14t-4-24q3-13 15-19t26-3q76 16 152 22.5t159 6.5q83 0 159-6.5T791-702q14-3 26 3t15 19q3 13-4 24t-21 14q-51 11-106.5 17.5T587-613v503q0 13-8.5 21.5T557-80q-13 0-21.5-8.5T527-110v-230h-94v230q0 13-8.5 21.5T403-80q-13 0-21.5-8.5T373-110Z"
		/>
	</svg>
);
